import { configureStore } from "@reduxjs/toolkit";
import  applicationsSlice  from "./slices/applicationSlice";
import chatsSlice from "./slices/chatsSlice";
import messagesSlice from "./slices/messagesSlice";
import popupSlice from "./slices/popupSlice";
import preferenceSlice from "./slices/preferenceSlice";
import ProfileSlice from "./slices/profileInfo";
import recommendedCoursesSlice from "./slices/recommendations";
import studentsInfo from "./slices/studentsInfo";
import userAuthSlice from "./slices/userAuthSlice";
import suggestedPackagesSlice from "./slices/suggestedPackagesSlice";
import { reviewsSlice } from "./slices/reviewSlice";

export const store = configureStore({
  reducer: {
    userAuthStatus: userAuthSlice,
    profileInfo: ProfileSlice,
    studentInfo: studentsInfo,
    applications:applicationsSlice,
    popup:popupSlice,
    recommendations:recommendedCoursesSlice,
    chats:chatsSlice,
    messages:messagesSlice,
    suggestedPackages:suggestedPackagesSlice,
    preferencesSlice:preferenceSlice,
    reviews:reviewsSlice as any
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
